import {
  Component, OnInit, Renderer2, ViewChild, ElementRef, Input,
  ChangeDetectorRef
} from '@angular/core';
import { ROUTES } from '../../sidebar/sidebar.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MENU, DEFAULT_PAGE, APP_ROUTES, generateUserRoute, generatePlanningRoute } from 'app/common/constants';
import { AuthUserService } from '../../core/services/auth-user.service';
import { ApiCacheService } from 'app/core/services/api-cache.service';


interface Menu {
  name: string;
  url: string;
  pages: Array<Record<string, any>>
  'page-name'?: string;
  'report-id'?: string;
  default: boolean;
  external?: boolean; // If true, opens in new tab as external link
}

@Component({
  moduleId: module.id,
  selector: 'navbar-cmp',
  templateUrl: 'navbar.component.html',
  styles: [`
    .nav-item p {
      font-size: 14.5px;
      color: #000000;
    }

    .nav-item {
      cursor: pointer;
    }

    .active{
      color: #1645DB !important;
    }
  `]
})
export class NavbarComponent implements OnInit {
  @Input() isClient: boolean = false;
  @Input() isClientPage: boolean = false;
  listTitles: any[];
  public pageTitle: string;
  location: Location;
  nativeElement: Node;
  toggleButton: Element;
  menu: Menu[];
  defaultPage: string = DEFAULT_PAGE;
  leftImage: string;
  leftImageHeight: number | string;
  showAdmin: boolean;
  customerName: string;
  reportMenu: Record<string, any>[];
  asDropdown = environment.navBar.asDropdown;
  params = window.location.href.split('/')
  private sidebarVisible: boolean;

  public isCollapsed = true;
  @ViewChild("navbar-cmp", { static: false }) button;
  @ViewChild('dropdownButton') dropdownButton: ElementRef;
  @ViewChild('content') content: ElementRef;

  constructor(private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    location: Location,
    private renderer: Renderer2,
    private element: ElementRef,
    private router: Router,
    private authUserService: AuthUserService,
    private apiCacheService: ApiCacheService) {

    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
    this.leftImage = `../../../../${environment.navBar.leftImage}`;
    this.leftImageHeight = environment.navBar.leftImageHeight;
    this.showAdmin = environment.navBar.showAdmin;

    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.dropdownButton && e.target !== this.dropdownButton.nativeElement && e.target !== this.content.nativeElement) {
        this.dropdownButton.nativeElement.setAttribute('class', 'dropdown-button');
      }
    });
  }

  ngOnInit() {
    const allowedPaths = Array.from(this.authUserService.AccessPages) || [];
    if (this.authUserService.IsDomainExcluded) {
      this.menu = [...MENU].map(m => ({
        ...m,
        url: m.url ?? m.name?.replace(/ /g, '-')
      }));
    } else {
      const menuItems = [
        ...MENU,
        {
          name: 'Inspection Planning',
          url: generatePlanningRoute(APP_ROUTES.PLANNING.MANAGE_INSPECTIONS)
        },
        { name: 'Users', url: generateUserRoute(APP_ROUTES.USER.LIST) }
      ];

      this.menu = menuItems
        .map(m => ({
          ...m,
          url: m.url ?? m.name?.replace(/ /g, '-')
        }))
        .filter(m =>
          allowedPaths.includes(m.url) || m.external
        ).filter((m, index, self) =>
          index === self.findIndex(item => item.name === m.name)
        );
    }

    this.customerName = this.activatedRoute.snapshot.firstChild?.url?.[0]?.path ?? '';
    const rptMenu = MENU.find(m => m.name === this.customerName);
    if (rptMenu?.pages?.length > 1) {
      this.reportMenu = rptMenu.pages?.filter(p => !p.hide)
    } else {
      this.reportMenu = [];
    }
    this.listTitles = ROUTES
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar?.getElementsByClassName('navbar-toggle')[0];
    this.getTitle();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route.snapshot.data['title'];
        }),
      )
      .subscribe((ttl: string | undefined) => {
        if (ttl) {
          this.pageTitle = ttl;
        }
      });
  }

  getMenuRouterLink(url: string | null | undefined): string {
    if (!url) return '/';
    return url.startsWith('/') ? url : `/${url}`;
  }

  clientNameMenuClicked(option: Menu) {
    this.customerName = option.name;
    if (option.pages.length > 1) {
      this.reportMenu = option.pages
        ?.filter(p => !p.hide)
    } else {
      this.reportMenu = []
    }
  }

  getTitle() {
    if (!this.isClient) {
      let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }
      const routeTitle = route.snapshot.data['title'];
      if (routeTitle) {
        this.pageTitle = routeTitle;
        return this.pageTitle;
      }

      var titlee = this.location.prepareExternalUrl(this.location.path());
      if (titlee.charAt(0) === '#') {
        titlee = titlee.slice(1);
      }
      for (var item = 0; item < this.listTitles.length; item++) {
        if (this.listTitles[item].path == titlee || titlee.includes(this.listTitles[item].path)) {
          this.pageTitle = this.listTitles[item].title;
          return this.pageTitle;
        }
      }
      this.pageTitle = 'Dashboard';
      return 'Dashboard';
    }
  }

  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const html = document.getElementsByTagName('html')[0];
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    setTimeout(function () {
      toggleButton?.classList?.add('toggled');
    }, 500);

    html.classList.add('nav-open');
    if (window.innerWidth < 991) {
      mainPanel.style.position = 'fixed';
    }
    this.sidebarVisible = true;
  };

  back(): void {
    this.location.back();
  }

  sidebarClose() {
    const html = document.getElementsByTagName('html')[0];
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    if (window.innerWidth < 991) {
      setTimeout(function () {
        if (mainPanel)
          mainPanel.style.position = '';
      }, 500);
    }
    this.toggleButton?.classList?.remove('toggled');
    this.sidebarVisible = false;
    html.classList.remove('nav-open');
  };

  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName('nav')[0];
    if (!this.isCollapsed) {
      if (!this.isClient) {
        navbar.classList.remove('navbar-transparent');
      }
      navbar.classList.add('bg-white');
    } else {
      if (!this.isClient) {
        navbar.classList.add('navbar-transparent');
      }
      navbar.classList.remove('bg-white');
    }
  }

  logout() {
    this.apiCacheService.clear()
    this.authUserService.logout();
  }

  openInspections() {
    this.router.navigate(['/twoeightone/inspection']);
  }
}
